// 화면을 옮기는 동안 바로 보이는 뼈대 — 레이아웃(레일·헤더)은 그대로 두고 본문 자리만 채운다.
const Loading = () => (
  <div aria-busy="true" aria-live="polite" className="flex flex-col gap-y-4" data-testid="app-loading" role="status">
    <span className="sr-only">불러오는 중…</span>
    <div className="h-0.5 w-full overflow-hidden rounded-full bg-muted">
      <div className="h-full w-1/3 animate-pulse rounded-full bg-primary" />
    </div>
    <div className="flex flex-col gap-y-2">
      <div className="h-6 w-48 animate-pulse rounded-md bg-muted" />
      <div className="h-4 w-72 max-w-full animate-pulse rounded-md bg-muted" />
    </div>
    <div className="h-32 w-full animate-pulse rounded-lg bg-muted" />
    <div className="h-48 w-full animate-pulse rounded-lg bg-muted" />
  </div>
);

export default Loading;
